export const PERSONAL_ACCOUNT_NAME = 'Personal account';
